import { ChangeDetectionStrategy, Component, ElementRef, inject, input, OnInit } from '@angular/core';
import { ratioAttribute } from '@df/module-image/df-image.directive';
import { UiComponent } from '@df/ui/ui.component';

function random(min: number, max: number) {
    return Math.random() * (max - min) + min;
}

@Component({
    selector: 'skeleton-rect',
    template: ``,
    styleUrl: './skeleton-rect.component.scss',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkeletonRectComponent extends UiComponent implements OnInit {
    width = input<string | undefined | 'rand'>();
    height = input<string>();
    ratio = input<string | number | undefined, string | number | 'auto'>(undefined, { transform: ratioAttribute });
    className = input<string>();

    protected host = inject(ElementRef<HTMLElement>).nativeElement;

    override ngOnInit(): void {
        if (this.className) {
            this.host.classList.add(this.className());
        }

        this.host.style.setProperty('--skeleton-rect-width', this.width() === 'rand' ? `${random(30, 90)}%` : (this.width() ?? '100%'));
        this.host.style.setProperty('--skeleton-rect-height', this.ratio() ? 'unset' : (this.height() ?? '22.4px'));
        this.host.style.setProperty('--skeleton-rect-aspect-ratio', this.ratio() ?? 'unset');

        super.ngOnInit();
    }
}
